import { createSlice } from '@reduxjs/toolkit'
const initialPage={
    activePage:''
}
const slice = createSlice({
    name: 'activePage',
    initialState: {
        activePage: initialPage,
    },
    reducers: {

      SetactivePage: (state, action) => {
        state.activePage = action.payload;
      }
    },
  });
  export default slice.reducer
  // Actions
  export const { SetactivePage} = slice.actions
